import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import { SearchPurchaseScheduleServiceOrderModel } from '../../../models/purchase-reservation.model'

@Injectable({
  providedIn: 'root',
})
export class PurchaseScheduleService {
  private baseUrl = environment.baseUrl
  private resource = 'AgendaCompras'

  constructor(private httpClient: HttpClient) {}

  public listPagedOs(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedOs(
    page: number,
    rows = 15,
    model: SearchPurchaseScheduleServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
